import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DeviceTableSlice {
  filter: Record<string, string[]>;
}

export const initialState: DeviceTableSlice = {
  filter: {
    id: [],
    name: [],
    health: [],
    strength: [],
    groups: [],
    model: [],
    location: [],
    description:[]
  },
};

const deviceTableSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<DeviceTableSlice["filter"]>) => {
      state.filter = action.payload;
    },
  },
});

export const { setFilter } = deviceTableSlice.actions;

export default deviceTableSlice;
